import useInsightsAnalytics, { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import { getReferralAnalyticsFilters, useReferralsInsightsStore } from 'stores/referralsInsightsStore';

export type ReferralAnalyticsQueryParams = InsightsQueryParams;

type Options = {
  queryKey?: string;
  enabled?: boolean;
  extraFilters?: Record<string, unknown> | null;
};

export default function useReferralAnalytics(
  queryParams: ReferralAnalyticsQueryParams,
  { queryKey = 'referralAnalytics', enabled = true, extraFilters = null }: Options = {}
) {
  const filters = useReferralsInsightsStore((state) => getReferralAnalyticsFilters(state));

  return useInsightsAnalytics(queryParams, filters, { queryKey, enabled, extraFilters });
}
